export interface IStatusCode {
  [key: string]: {
    short: string;
    long: string;
  };
}
